/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DateRange } from './dateRange';

export interface OutgoingInvoicesPerOperationalFileFilter { 
    pageSize?: number;
    page?: number;
    readonly listSortDirection?: OutgoingInvoicesPerOperationalFileFilter.ListSortDirectionEnum;
    sortDirection?: string;
    sortProperty?: string;
    fileNumber?: Array<string>;
    invoiceNumber?: Array<string>;
    invoiceDate?: Array<DateRange>;
    customerName?: Array<string>;
    customerNumber?: Array<string>;
    shipmentType?: Array<OutgoingInvoicesPerOperationalFileFilter.ShipmentTypeEnum>;
    fileType?: Array<OutgoingInvoicesPerOperationalFileFilter.FileTypeEnum>;
    transportType?: Array<OutgoingInvoicesPerOperationalFileFilter.TransportTypeEnum>;
    portOfLoading?: Array<string>;
    portOfDischarge?: Array<string>;
    airportOfDestination?: Array<string>;
    airportOfDeparture?: Array<string>;
}
export namespace OutgoingInvoicesPerOperationalFileFilter {
    export type ListSortDirectionEnum = 0 | 1;
    export const ListSortDirectionEnum = {
        NUMBER_0: 0 as ListSortDirectionEnum,
        NUMBER_1: 1 as ListSortDirectionEnum
    };
    export type ShipmentTypeEnum = '0' | '1' | '2' | '3' | '4' | '5' | '6';
    export const ShipmentTypeEnum = {
        _0: '0' as ShipmentTypeEnum,
        _1: '1' as ShipmentTypeEnum,
        _2: '2' as ShipmentTypeEnum,
        _3: '3' as ShipmentTypeEnum,
        _4: '4' as ShipmentTypeEnum,
        _5: '5' as ShipmentTypeEnum,
        _6: '6' as ShipmentTypeEnum
    };
    export type FileTypeEnum = '0' | '1' | '2' | '3' | '4' | '5' | '6';
    export const FileTypeEnum = {
        _0: '0' as FileTypeEnum,
        _1: '1' as FileTypeEnum,
        _2: '2' as FileTypeEnum,
        _3: '3' as FileTypeEnum,
        _4: '4' as FileTypeEnum,
        _5: '5' as FileTypeEnum,
        _6: '6' as FileTypeEnum
    };
    export type TransportTypeEnum = '0' | '1' | '2' | '3';
    export const TransportTypeEnum = {
        _0: '0' as TransportTypeEnum,
        _1: '1' as TransportTypeEnum,
        _2: '2' as TransportTypeEnum,
        _3: '3' as TransportTypeEnum
    };
}